import { useQuery } from '@tanstack/react-query';
import { getSiteUrls } from './endpoints';
import { sitePreviewKeys } from './keys';
import { useMsId } from '../../../store/appStore';

export function useSiteUrls() {
  const metaSiteId = useMsId();

  return useQuery<string>({
    queryKey: sitePreviewKeys.getSiteUrls(metaSiteId || ''),
    queryFn: () => getSiteUrls(metaSiteId || ''),
    enabled: !!metaSiteId,
    staleTime: 30000, // 30 seconds
    retry: 3,
    retryDelay: 2000,
  });
}
